import { render, staticRenderFns } from "./ChartWithCompanionKpis.vue?vue&type=template&id=667b0eb8&"
import script from "./ChartWithCompanionKpis.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChartWithCompanionKpis.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports